// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-customer-modal-modal_card-vmtB9 {
  width: 564px;
  height: 772px;
}

.edit-customer-modal-modal_content-yiTeQ {
  overflow: scroll;
  padding: 0px 14px 0px 24px;
}

.edit-customer-modal-customerTitle-FXEth {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 500;
  font-size: 15px;
  margin-top: 26px;
}

.edit-customer-modal-businessTitle-oM3j8 {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 500;
  font-size: 15px;
  margin-top: 40px;
}

.edit-customer-modal-fieldsContent-PSpo0 {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.edit-customer-modal-textField_container-CIazy, .edit-customer-modal-select_container-RmYDn {
  width: 240px;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/edit-customer-modal/edit-customer-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 564px;\n  height: 772px;\n}\n\n.modal_content {\n  overflow: scroll;\n  padding: 0px 14px 0px 24px;\n}\n\n.customerTitle {\n  color: rgba(0, 0, 0, 0.9);\n  font-weight: 500;\n  font-size: 15px;\n  margin-top: 26px;\n}\n\n.businessTitle {\n  color: rgba(0, 0, 0, 0.9);\n  font-weight: 500;\n  font-size: 15px;\n  margin-top: 40px;\n}\n\n.fieldsContent {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n\n.textField_container, .select_container {\n  width: 240px;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `edit-customer-modal-modal_card-vmtB9`,
	"modal_content": `edit-customer-modal-modal_content-yiTeQ`,
	"customerTitle": `edit-customer-modal-customerTitle-FXEth`,
	"businessTitle": `edit-customer-modal-businessTitle-oM3j8`,
	"fieldsContent": `edit-customer-modal-fieldsContent-PSpo0`,
	"textField_container": `edit-customer-modal-textField_container-CIazy`,
	"select_container": `edit-customer-modal-select_container-RmYDn`
};
export default ___CSS_LOADER_EXPORT___;
